import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { BookOpen, Monitor, DollarSign, ArrowRight, Check, Bot } from 'lucide-react'

gsap.registerPlugin(ScrollTrigger)

const modules = [
  {
    id: 'academico',
    badge: 'Docentes, Estudiantes y Padres de familia',
    badgeColor: '#10B981',
    badgeBg: 'rgba(16,185,129,0.1)',
    title: 'Módulo Académico',
    description:
      'Gestión completa del ciclo académico: matrículas, calificaciones, boletines, horarios, observador del estudiante y seguimiento pedagógico.',
    features: [
      'Registro de notas por competencias',
      'Generación automática de boletines',
      'Observador del estudiante digital',
      'Inasistencias en tiempo real y alertas automáticas',
    ],
    icon: BookOpen,
    image: '/hero-academico.jpg',
    gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
  },
  {
    id: 'aula-virtual',
    badge: 'VIRTUAL',
    badgeColor: '#0F293E',
    badgeBg: 'rgba(15,41,62,0.1)',
    title: 'Módulo Aula Virtual',
    description:
      'Entorno de aprendizaje digital con recursos multimedia, foros de discusión, tareas interactivas, videoconferencias integradas y seguimiento de participación.',
    features: [
      'Videoconferencias integradas',
      'Foros y trabajos colaborativos',
      'Banco de recursos educativos',
      'Seguimiento de participación',
    ],
    icon: Monitor,
    image: '/modulo-aula-virtual.jpg',
    gradient: 'linear-gradient(135deg, #0F293E 0%, #1a3a52 100%)',
  },
  {
    id: 'financiero',
    badge: 'Administrativos',
    badgeColor: '#F59E0B',
    badgeBg: 'rgba(245,158,11,0.1)',
    title: 'Módulo Financiero',
    /* title: 'Desarrollo del Módulo Contable', */
    description:
      'Control total de la tesorería escolar: cobro de pensiones, consignaciones, facturación electrónica, presupuestos y reportes financieros en tiempo real.',
   /*  description:
      'Control total de la gestión contable: facturación electrónica, presupuestos y reportes financieros en tiempo real.', */
    features: [
      'Cobro de pensiones y pagos online',
      /* 'Gestión de nóminas y pagos a proveedores', */
      'Facturación electrónica automatizada',
      /* 'Presupuestos y reportes financieros', */
      'Reportes de cobros y pagos',
    ],
    icon: DollarSign,
    image: '/modulo-financiero.jpg',
    gradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
  },
  {
    id: 'alania',
    badge: 'Inteligencia Artificial',
    badgeColor: '#10B981',
    badgeBg: 'rgba(16,185,129,0.1)',
    title: 'Módulo AlanIA',
    /* title: 'Desarrollo del Módulo Contable', */
    description:
      'Asistente de IA para la gestión investigativa',
    features: [
      'Enfocada exclusivamente en educación y acompañamiento académico',
      'Personalización de la experiencia de usuario',
      'Traducción a más de 5 idiomas',
      'Conversación natural y contextualizada en tiempo real con varios idiomas',
    ],
    icon: Bot,
    image: '/alania-agarrando-app.png',
    gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
  }
]

const Modules = () => {
  const sectionRef = useRef(null)
  const headerRef = useRef(null)
  const cardsRef = useRef(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        headerRef.current.children,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: headerRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none',
          },
        }
      )

      gsap.fromTo(
        cardsRef.current.children,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          stagger: 0.15,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: cardsRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none',
          },
        }
      )
    }, sectionRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      id="modulos"
      ref={sectionRef}
      className="section-padding"
      style={{ backgroundColor: 'white' }}
    >
      <div className="container-main">
        <div ref={headerRef} className="text-center mb-16">
          <span
            className="badge-pill"
            style={{
              backgroundColor: 'rgba(16,185,129,0.1)',
              color: '#10B981',
              fontSize: '12px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            NUESTROS MÓDULOS EN ESTA PROPUESTA
          </span>
          <h2
            className="mt-4 text-3xl md:text-[40px] font-bold"
            style={{ color: '#0F293E', lineHeight: 1.2 }}
          >
            Soluciones diseñadas para cada área de tu colegio, integradas y optimizadas para trabajar juntas.
          </h2>
          <p
            className="mt-4 text-lg mx-auto"
            style={{
              color: '#4B5563',
              lineHeight: 1.6,
              maxWidth: 640,
            }}
          >
            Selecciona los módulos que tu colegio necesita. Integrados
            nativamente, funcionan mejor juntos.
          </p>
        </div>

        <div
          ref={cardsRef}
          className="grid grid-cols-1 md:grid-cols-2 gap-8"
        >
          {modules.map((mod) => (
            <div
              key={mod.id}
              className="group bg-white rounded-[20px] overflow-hidden transition-all duration-400"
              style={{
                boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)',
                border: '1px solid transparent',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)'
                e.currentTarget.style.boxShadow = '0 25px 40px -5px rgba(0,0,0,0.12)'
                e.currentTarget.style.borderColor = mod.badgeColor
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0px)'
                e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(0,0,0,0.1)'
                e.currentTarget.style.borderColor = 'transparent'
              }}
            >
              {/* Image area */}
              <div
                className="relative h-[200px] flex items-center justify-center overflow-hidden"
                style={{ background: mod.gradient }}
              >
                <img
                  src={mod.image}
                  alt={mod.title}
                  className="w-full h-full object-cover opacity-30"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <mod.icon size={48} color="white" strokeWidth={1.5} />
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <span
                  className="badge-pill mb-3"
                  style={{
                    backgroundColor: mod.badgeBg,
                    color: mod.badgeColor,
                    fontSize: '11px',
                    padding: '4px 10px',
                  }}
                >
                  {mod.badge}
                </span>
                <h3
                  className="text-2xl font-bold"
                  style={{ color: '#0F293E' }}
                >
                  {mod.title}
                </h3>
                <p
                  className="mt-3 text-[15px] leading-relaxed"
                  style={{ color: '#4B5563', lineHeight: 1.7 }}
                >
                  {mod.description}
                </p>

                <ul className="mt-5 space-y-2">
                  {mod.features.map((feat) => (
                    <li key={feat} className="flex items-start gap-2">
                      <Check
                        size={16}
                        color="#10B981"
                        strokeWidth={3}
                        className="mt-0.5 flex-shrink-0"
                      />
                      <span
                        className="text-sm"
                        style={{ color: '#374151' }}
                      >
                        {feat}
                      </span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() =>
                    document
                      .getElementById('solicitar-demo')
                      ?.scrollIntoView({ behavior: 'smooth' })
                  }
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold cursor-pointer group/btn"
                  style={{ color: '#10B981' }}
                >
                  Conocer más
                  <ArrowRight
                    size={16}
                    className="transition-transform duration-200 group-hover/btn:translate-x-1"
                  />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Modules
